import React, { Fragment, useEffect } from 'react';

import SideNav from '../../Components/SideNav';
import ListaAdmin from '../../Components/ListaAdmin';
import FilaAdmin, { Insignia } from '../../Components/FilaAdmin';
import Paginacion from '../../Components/Paginacion';
import BarraArchivar from '../../Components/ArchivarMasivo/BarraArchivar';
import CheckSeleccion from '../../Components/ArchivarMasivo/CheckSeleccion';

import useListaPaginada from '../../Hooks/useListaPaginada';
import useSeleccionArchivado from '../../Hooks/useSeleccionArchivado';

import { etiquetaLicenciatura, formatearFecha } from '../../Helpers/solicitudes';

const CLAVES = ['licenciatura', 'estado'];
const FIJOS = { archivado: 'false' };

const ESTADOS = [
    { valor: undefined, etiqueta: 'Todas' },
    { valor: 'pendiente', etiqueta: 'Pendientes' },
    { valor: 'atendido', etiqueta: 'Atendidas' }
];

// Solicitudes sin archivar de inscripción o reinscripción. extraFila: texto extra del subtítulo (cuatrimestre y grupo en reinscripción)
const VistaSolicitudes = ({ helper, encabezado, licenciaturas, rutaDetalle, extraFila }) => {
    const lista = useListaPaginada({ obtener: helper.listar, claves: CLAVES, fijos: FIJOS });
    const seleccion = useSeleccionArchivado(helper, lista.recargar);

    // La selección es de la página que se ve: al cambiar de página o de filtro se limpia para no archivar algo oculto
    useEffect(() => {
        seleccion.limpiar();
    }, [lista.llave]);

    const { licenciatura, estado } = lista.filtros;

    return (
        <Fragment>
            <SideNav />
            <div className='row'>
                <ListaAdmin
                    etiqueta='Solicitudes'
                    encabezado={encabezado}
                    ayuda='Haz clic en una solicitud para ver sus datos y documentos. Las atendidas se pueden archivar en grupo.'
                    busqueda={lista.busqueda}
                    onBusqueda={lista.setBusqueda}
                    placeholder='Buscar por nombre o correo'
                    conteo={`${lista.total.toLocaleString('es-MX')} ${lista.total === 1 ? 'solicitud' : 'solicitudes'}`}
                    mostrados={lista.registros.length}
                    cargando={lista.cargando}
                    actualizando={lista.actualizando}
                    textoVacio='No hay solicitudes con estos filtros.'
                    filtros={
                        <Fragment>
                            <select className='browser-default' value={licenciatura ?? 'todas'} onChange={e => lista.setFiltro('licenciatura', e.target.value === 'todas' ? undefined : e.target.value)} aria-label='Licenciatura'>
                                <option value='todas'>Todas las licenciaturas</option>
                                {licenciaturas.map(({ valor, etiqueta }) => <option key={valor} value={valor}>{etiqueta}</option>)}
                            </select>
                            <div className='segmentado_admin' role='group' aria-label='Estado'>
                                {ESTADOS.map(({ valor, etiqueta }) => (
                                    <button type='button' key={etiqueta} aria-pressed={estado === valor} onClick={() => lista.setFiltro('estado', valor)}>
                                        {etiqueta}
                                    </button>
                                ))}
                            </div>
                            <CheckSeleccion
                                label='Seleccionar las atendidas de esta página'
                                checked={seleccion.bloqueCompleto(lista.registros)}
                                disabled={seleccion.bloqueVacio(lista.registros)}
                                onChange={() => seleccion.toggleBloque(lista.registros)}
                            />
                        </Fragment>
                    }
                    migas={seleccion.total > 0 && (
                        <BarraArchivar total={seleccion.total} onArchivar={seleccion.archivar} onLimpiar={seleccion.limpiar} />
                    )}
                    pie={lista.total > 0 && (
                        <Paginacion pagina={lista.pagina} limite={lista.limite} total={lista.total} onPagina={lista.setPagina} onLimite={lista.setLimite} />
                    )}
                >
                    {lista.registros.map(solicitud => (
                        <FilaAdmin
                            key={solicitud._id}
                            href={rutaDetalle + solicitud._id}
                            antes={
                                <CheckSeleccion
                                    checked={seleccion.estaSeleccionado(solicitud._id)}
                                    disabled={solicitud.estadoAlumno !== true}
                                    title={solicitud.estadoAlumno !== true ? 'Solo se pueden archivar solicitudes atendidas' : 'Seleccionar para archivar'}
                                    onChange={() => seleccion.toggle(solicitud._id)}
                                />
                            }
                            icono={solicitud.estadoAlumno ? 'task_alt' : 'schedule'}
                            titulo={solicitud.nombre || '(Sin nombre)'}
                            subtitulo={[solicitud.email, formatearFecha(solicitud.fecha), extraFila?.(solicitud)].filter(Boolean).join(' · ')}
                            insignias={
                                <Fragment>
                                    <Insignia variante='gris'>{etiquetaLicenciatura(licenciaturas, solicitud.licenciatura)}</Insignia>
                                    <Insignia variante={solicitud.estadoAlumno ? 'verde' : 'amarilla'}>{solicitud.estadoAlumno ? 'Atendida' : 'Pendiente'}</Insignia>
                                </Fragment>
                            }
                        />
                    ))}
                </ListaAdmin>
            </div>
        </Fragment>
    );
};

export default VistaSolicitudes;
